import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
  DirectionsRenderer,
  DirectionsService,
  Autocomplete,
  LoadScript,
} from '@react-google-maps/api';
interface UserMapData {
  lat: number;
  lng: number;
}

interface Props {
  lat: number;
  lng: number;
  height: string;
  zoom?: number;
  showInfoWindow?: boolean;
  children?: any;
  icon?: any
  formatted_address?: string;
  mapAddressFiled?: any;
  mapCurrentPosition?: any;
  isRouteDirection?: boolean
  originLocation?: any;
  destinationLocation?: any
  isSearchEnabled?: boolean;
}

const Map: React.FC<Props> = ({
  lat,
  lng,
  height,
  zoom,
  showInfoWindow,
  mapCurrentPosition,
  icon,
  isRouteDirection,
  originLocation,
  destinationLocation,
  isSearchEnabled
}) => {
  const containerStyle = {
    width: '100%',
    height: height || '420px',
  };
  const libraries: any = ['places'];
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [searchLngLat, setSearchLngLat] = useState<any>(null);
  const autocompleteRef = useRef<any>(null);
  const [address, setAddress] = useState("");

  const center = {
    lat: Number(lat) || 10.9601,
    lng: Number(lng) || 78.0766,
  };
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyDOCJ7V-QaS9nnf7zZ1B7ZEgrkI-YcxWA0', // replace with your key
    libraries,
  });


  const [directionsResponse, setDirectionsResponse] = useState(null);

  const [selectedMarker, setSelectedMarker] = useState<any>();
  // const [marker, setMarker] = useState<any>('/assets/images/indicator.png');
  const [mapPosition, setMapPosition] = useState<UserMapData | null>(null);
  const [infoWindowToggle, setInfoWindowToggle] = useState<boolean>(false);


  const onMarkerDragEnd = (e: any) => {
    if (e.domEvent.type === 'click') {
      setInfoWindowToggle(true);
    }
    // if (e.domEvent.type !== 'click') {
    //   setMarker('/assets/images/indicator-2.png');
    // }

    const geocoder = new (window as any).google.maps.Geocoder();
    const latLng = {
      lat: parseFloat(e.latLng.lat()),
      lng: parseFloat(e.latLng.lng()),
    };
    geocoder
      .geocode({ location: latLng })
      .then((response: any) => {
        if (response.results[0]) {
          if (mapCurrentPosition !== undefined) {
            mapCurrentPosition(response.results[0]?.formatted_address);
          }
          setSelectedMarker(response.results[0]);
          setMapPosition(latLng);
          setInfoWindowToggle(true);

        } else {
          window.alert('No results found');
        }
      })
      .catch((e: any) => window.alert('Geocoder failed due to: ' + e));
  };



  const onLoad = React.useCallback(function callback(map: any) {

    const directionsService = new window.google.maps.DirectionsService();
    directionsService.route(
      {
        origin: originLocation,
        destination: destinationLocation,
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (result: any, status) => {
        if (status === google.maps.DirectionsStatus.OK) {

          setDirectionsResponse(result);
        } else {
          console.error(`error fetching directions ${result}`);
        }
      }
    );



  }, [isLoaded])

  const handlePlaceChanged = () => {
    const place = autocompleteRef.current.getPlace();
    setSelectedPlace(place);
    setSearchLngLat({
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    });

  };


  if (!isLoaded) return <div>Loading...</div>;

  return (
    <>

      {isSearchEnabled && <Autocomplete
        onLoad={(autocomplete) => {

          autocompleteRef.current = autocomplete;
        }}
        onPlaceChanged={handlePlaceChanged}
        className="p-15 cursor-pointer"
        options={{ fields: ["address_components", "geometry", "name", "adr_address", "business_status", "formatted_address", "place_id", "type", "icon", "icon_mask_base_uri", "icon_background_color", "photo"] }}
      >
        <input type="text" placeholder="Search for a location"
          className="text-heading outline-none w-full h-[40px] ps-2 md:ps-6 pe-4 md:pe-4 bg-skin-full text-skin-base text-sm lg:text-15px border border-skin-base rounded-md transition-all duration-200 focus:border-skin-primary focus:ring-1 focus:ring-skin-form" />
      </Autocomplete>}


      <GoogleMap
        mapContainerStyle={containerStyle}
        center={mapPosition || center}
        zoom={zoom || 15}
        onLoad={onLoad}

      >
        <Marker
          position={mapPosition || center}
          draggable={true}
          visible={true}
          icon={icon || '/assets/images/pin.png'}
          onDragEnd={(e) => onMarkerDragEnd(e)}
          onClick={(e) => onMarkerDragEnd(e)}
        // animation="BOUNCE"
        ></Marker>
        {isRouteDirection ? (
          // Render DirectionsRenderer when isRouteDirection is true and directionsResponse is available
          directionsResponse && (
            <DirectionsRenderer directions={directionsResponse} />
          )
        ) : (
          // Render Marker when isRouteDirection is false
          <Marker
            position={mapPosition || center}
            draggable={true}
            visible={true}
            icon={icon || '/assets/images/pin.png'}
            onDragEnd={(e) => onMarkerDragEnd(e)}
            onClick={(e) => onMarkerDragEnd(e)}
          // animation="BOUNCE"
          >
            {showInfoWindow && infoWindowToggle && (
              <InfoWindow
                position={mapPosition || center}
                onCloseClick={() => setInfoWindowToggle(false)}
              >
                <p>{selectedMarker?.formatted_address}</p>
              </InfoWindow>
            )}
          </Marker>
        )}
        {/* <SearchBox /> */}
      </GoogleMap>

    </>
  )
};

export default React.memo(Map);
